import { configureStore } from "@reduxjs/toolkit";

import themeReducer from "./slices/themeSlice";
import homeReducer from "./slices/homeSlice";

export const store = configureStore({
  reducer: {
    theme: themeReducer,
    home: homeReducer,
  },
});
